import { render, staticRenderFns } from "./RemovePlanDialog.vue?vue&type=template&id=948b1634&lang=pug&"
import script from "./RemovePlanDialog.vue?vue&type=script&lang=js&"
export * from "./RemovePlanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports